import {BrowserModule} from '@angular/platform-browser';
import {CommonModule, registerLocaleData} from '@angular/common';
import {NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import localeDe from '@angular/common/locales/de';

import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {ToastrModule} from 'ngx-toastr';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {NgxSpinnerModule} from 'ngx-spinner';

import {CustomTranslateHttpLoader, GastCommonNgModule, selectEnvironmentFile, TranslationService} from 'gast-common-ng';
import {GastPortalNgModule} from 'gast-portal-ng';
import {GastOnsetNgModule} from 'gast-onset-ng';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {RouterModule} from '@angular/router';
import {ModalModule} from 'ngx-bootstrap/modal';

import {environment} from '../environments/environment';
import {VerificationComponent} from './verification/verification.component';
import {CertificateService} from './shared/services/certificate.service';
import {UrlService} from './shared/services/url.service';
import {FormsModule} from '@angular/forms';
import {VerificationTestdafDigitalComponent} from './verification-testdaf-digital/verification-testdaf-digital.component';
import {VerificationTestdafFormComponent} from './verification-testdaf-form/verification-testdaf-form.component';
import {BsDatepickerModule, defineLocale, deLocale, enGbLocale, frLocale, ptBrLocale} from 'ngx-bootstrap';
import {VerificationTestasFormComponent} from './verification-testas-form/verification-testas-form.component';
import {VerificationDmatFormComponent} from './verification-dmat-form/verification-dmat-form.component';
import {VerificationDtzFormComponent} from './verification-dtz-form/verification-dtz-form.component';
import {VerificationDtzChoiceComponent} from './verification-dtz-choice/verification-dtz-choice.component';
import {VerificationDtzQrCodeComponent} from './verification-dtz-qr-code/verification-dtz-qr-code.component';
import {VerificationDtzPdfFormComponent} from './verification-dtz-pdf-form/verification-dtz-pdf-form.component';
import { VerificationBestOfCertificateTestdafComponent } from './verification-best-of-certificate-testdaf/verification-best-of-certificate-testdaf.component';
// import {RECAPTCHA_V3_SITE_KEY, RecaptchaModule, RecaptchaV3Module} from 'ng-recaptcha';

registerLocaleData(localeDe);

// locale for ngx-datepicker
defineLocale('de', deLocale);
defineLocale('en', enGbLocale);
defineLocale('fr', frLocale);
defineLocale('pt', ptBrLocale);

export function HttpLoaderFactory(httpClient: HttpClient) {
  const urls: Array<string> = [
    './common-assets/i18n/',
    './portal-assets/i18n/',
    './assets/i18n/'
  ];
  return new CustomTranslateHttpLoader(httpClient, urls, '.json');
}

export function TranslationServiceFactory(translationService: TranslationService) {
  return translationService;
}

@NgModule({
  declarations: [
    AppComponent,
    VerificationComponent,
    VerificationTestdafDigitalComponent,
    VerificationTestdafFormComponent,
    VerificationTestasFormComponent,
    VerificationDmatFormComponent,
    VerificationDtzFormComponent,
    VerificationDtzChoiceComponent,
    VerificationDtzQrCodeComponent,
    VerificationDtzPdfFormComponent,
    VerificationBestOfCertificateTestdafComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    // RecaptchaV3Module,
    // RecaptchaModule,
    HttpClientModule,
    RouterModule,
    CommonModule,
    FormsModule,
    NgxDatatableModule,
    BsDatepickerModule,
    ToastrModule.forRoot(),
    GastPortalNgModule.forRoot({
      provide: TranslationService,
      useFactory: TranslationServiceFactory,
      deps: [TranslateService]
    }),
    GastCommonNgModule.forRoot(),
    GastOnsetNgModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxSpinnerModule,
    ModalModule.forRoot()
  ],
  providers: [
    {
      provide: 'env',
      useValue: {callback: selectEnvironmentFile, value: environment.envName}
    },
    CertificateService,
    UrlService,
    // {provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.googleRecaptchaKeySite}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
